import { ApiProperty } from "@nestjs/swagger";

export class UserDateReq {
   @ApiProperty()
   fromDate: string;
   @ApiProperty()
   toDate: string;
   @ApiProperty()
   userName: string;
}